module.exports = __webpack_public_path__ + "img/line_btn.9d6f54a5.svg";